import { useNavigate, useParams } from "react-router";
import styles from "./index.module.css";
import { TitleComponent } from "Components/Title";
import arrowLeftBack from "assets/svg/ArrowLeftBack.svg";
import { Button, Spin } from "antd";
import { useCallback, useContext, useState } from "react";
import { CopyButton } from "Components/CopyButton";
import { UserDisputChat } from "../../Users/UserComponent/UserChat";
import { DealsInfo } from "Components/DealsInfo";
import { ModalComponent } from "Components/ModalComponent";
import { ManageModalDisputes } from "../ManageModalDisputes";
import { useRequest } from "ahooks";
import { AdminContext } from "context/adminContext";
import { NotificationContext } from "context/notificationContext";
import { cancelDebate, getDebateDetails, startDebateProcess } from "helpers/backend_helper";
import { DebateStatuses } from "helpers/types";
import { CustomButton } from "Components/CustomButton";

const STATUS_MATCH = {
  IN_PROGRESS: "In Process",
  CANCELLED: "Declined",
  WAIT: "Requested",
  COMPLETED: "Completed",
  COMPLETE: "Completed",
};
export const DisputeDetails = () => {
  const { dealId } = useParams();
  const { localCountry } = useContext(AdminContext);
  const { openNotificationWithIcon } = useContext(NotificationContext);
  const [currentStatus, setCurrentStatus] = useState<DebateStatuses>();
  const [isOpenDetails, setOpenDetails] = useState(false);
  const [declineOpen, setDeclineOpen] = useState(false);
  const [startOpen, setStartOpen] = useState(false);
  const [refreshDealsInfo, setRefreshDealInfo] = useState(false);
  const [isManageDisputeOpen, setIsManageDisputeOpen] = useState(false);
  const [isReport, setIsReport] = useState(false);
  const navigate = useNavigate();

  const {
    data: debateDetails,
    loading: isLoadingDebateDetails,
    refresh: refreshDebate,
  } = useRequest(() => getDebateDetails(dealId, localCountry.iso.toUpperCase()), {
    ready: !!localCountry?.iso,
    onError: (err: any) => {
      openNotificationWithIcon("error", err.response?.data?.message || err.message);
    },
    onSuccess: (data) => {
      setCurrentStatus(data.status);
    },
  });
  console.log(debateDetails);
  const closeDeclineOrStartModal = useCallback(() => {
    setDeclineOpen(false);
    setStartOpen(false);
  }, []);

  const { run: cancelDispute, loading: isCancelDisputeLoading } = useRequest(
    () => cancelDebate(debateDetails.id, localCountry.iso.toUpperCase()),
    {
      manual: true,
      ready: !!localCountry?.iso && !!debateDetails,
      refreshDeps: [debateDetails, localCountry?.iso],
      onError: (err: any) => {
        openNotificationWithIcon("error", err.response?.data?.message || err.message);
      },
      onSuccess: (data) => {
        if (data) {
          setRefreshDealInfo((prev) => !prev);
          refreshDebate();
        }
      },
    },
  );

  const { run: onStartDebateProcess, loading: isOnStartDebateLoading } = useRequest(
    () => startDebateProcess(debateDetails.id, localCountry.iso.toUpperCase()),
    {
      manual: true,
      ready: !!localCountry?.iso && !!debateDetails,
      refreshDeps: [debateDetails, localCountry?.iso],
      onError: (err: any) => {
        openNotificationWithIcon("error", err.response?.data?.message || err.message);
      },
      onSuccess: (data) => {
        if (data) {
          setRefreshDealInfo((prev) => !prev);
          refreshDebate();
        }
      },
    },
  );
  const onDecline = useCallback(() => {
    cancelDispute();
  }, [cancelDispute]);
  const onStart = useCallback(() => {
    onStartDebateProcess();
  }, [onStartDebateProcess]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.btnTitle}>
            <Button
              type="text"
              className={styles.btnBack}
              icon={<img src={arrowLeftBack} alt="arrow back" />}
              onClick={() => {
                navigate(-1);
              }}
            />
            <TitleComponent text="Dispute" />
          </div>
          {isLoadingDebateDetails ? (
            <Spin />
          ) : (
            <>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span className={styles.grayTitle}>ID</span>
                <CopyButton copyText="copied!" text={dealId} wait={1000} sliceOfText={7} className={styles.copyBtn} />
              </div>
              {currentStatus !== "WAIT" && (
                <>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span className={styles.grayTitle}>Support ID</span>
                    <CopyButton
                      copyText="copied!"
                      text={dealId}
                      wait={1000}
                      sliceOfText={7}
                      className={styles.copyBtn}
                    />
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span className={styles.grayTitle}>Dates</span>
                    <span className={styles.dateTitle}>
                      {debateDetails?.resolvedAt
                        ? new Date(debateDetails.createdAt)
                            .toLocaleDateString("eng", {
                              month: "short",
                              day: "2-digit",
                            })
                            .split(" ")
                            .join(", ") +
                          " — " +
                          new Date(debateDetails?.resolvedAt)
                            .toLocaleDateString("eng", {
                              month: "short",
                              day: "2-digit",
                            })
                            .split(" ")
                            .join(", ")
                        : new Date(debateDetails.createdAt)
                            .toLocaleDateString("eng", {
                              month: "short",
                              day: "2-digit",
                            })
                            .split(" ")
                            .join(", ")}
                    </span>
                  </div>
                </>
              )}
              <CustomButton
                sizeButton="medium"
                typeButton="primary"
                onClick={() => {
                  setOpenDetails(true);
                }}
              >
                Deal Info
              </CustomButton>

              <div className={styles.changeStatus}>
                {currentStatus ? (
                  <>
                    <span>Status</span>
                    <span>{STATUS_MATCH[currentStatus]}</span>
                    {currentStatus === "WAIT" ? (
                      <>
                        <CustomButton
                          sizeButton="medium"
                          typeButton="primary"
                          onClick={() => {
                            setStartOpen(true);
                          }}
                          loading={isOnStartDebateLoading}
                        >
                          Start Dispute
                        </CustomButton>
                        <CustomButton
                          sizeButton="medium"
                          typeButton="critical"
                          onClick={() => {
                            setDeclineOpen(true);
                          }}
                          loading={isCancelDisputeLoading}
                          disabled={
                            debateDetails?.rent?.returnWithDispute ||
                            debateDetails.system_return_initiation ||
                            debateDetails.system_transfer_initiation
                          }
                        >
                          Decline Dispute
                        </CustomButton>
                      </>
                    ) : currentStatus === "IN_PROGRESS" ? (
                      <>
                        <CustomButton
                          sizeButton="medium"
                          typeButton="primary"
                          onClick={() => {
                            setIsManageDisputeOpen(true);
                          }}
                        >
                          Manage
                        </CustomButton>
                      </>
                    ) : currentStatus === "COMPLETED" ? (
                      <>
                        <CustomButton
                          sizeButton="medium"
                          typeButton="primary"
                          className={styles.confirmBtn}
                          onClick={() => {
                            setIsReport(true);
                            setIsManageDisputeOpen(true);
                          }}
                        >
                          Report
                        </CustomButton>
                      </>
                    ) : null}
                  </>
                ) : (
                  <Spin
                    style={{ width: "100%", height: "100%", top: "50%", left: "50%", transform: "transform(50% -50%)" }}
                  />
                )}
              </div>
            </>
          )}
        </div>
        <UserDisputChat
          idChat={debateDetails?.chat?.id}
          className={styles.userChat}
          debateId={debateDetails?.id}
          userId={debateDetails?.product?.userId}
        />
      </div>
      {debateDetails && (
        <DealsInfo
          refreshState={refreshDealsInfo}
          close={() => {
            setOpenDetails(false);
          }}
          isOpen={isOpenDetails}
          id={debateDetails?.rent?.id}
        />
      )}
      <ModalComponent
        isOpen={declineOpen}
        onClose={closeDeclineOrStartModal}
        buttons={{
          confirm: {
            label: "Decline Dispute",
            onConfirm: onDecline,
            isDanger: true,
          },
          decline: {
            label: "Cancel",
            onDecline: closeDeclineOrStartModal,
          },
        }}
        content={
          debateDetails?.system_transfer_initiation
            ? "Please make sure that the product has been transferred on the initial date"
            : debateDetails?.system_return_initiation
            ? "Please make sure that the product has been returned on the initial date"
            : "Please confirm that you decline the Dispute"
        }
        title="Decline Dispute"
      />

      <ModalComponent
        isOpen={startOpen}
        onClose={closeDeclineOrStartModal}
        buttons={{
          confirm: {
            label: "Start Dispute",
            onConfirm: onStart,
          },
          decline: {
            label: "Cancel",
            onDecline: closeDeclineOrStartModal,
          },
        }}
        content={
          debateDetails?.system_transfer_initiation
            ? "Please make sure that the product has not been transferred on the initial date"
            : debateDetails?.system_return_initiation
            ? "Please make sure that the product has not been returned on the initial date"
            : "Please confirm that you start the Dispute"
        }
        title="Start Dispute"
      />
      {debateDetails && (
        <ManageModalDisputes
          debateInfo={debateDetails}
          close={() => {
            setIsManageDisputeOpen(false);
            setIsReport(false);
          }}
          isOpen={isManageDisputeOpen}
          onRefreshDebate={refreshDebate}
          isReport={isReport}
          insuranceType={debateDetails.rent.insuranceType}
        />
      )}
    </>
  );
};
